<template>
  <div v-if="productData" :class="rootCss" :style="showCard ? 'display:block' : 'display:none'">
    <div class="row m-0">
      <span
        class="closeQuickModal"
        v-on:click="closeModal"
        v-show="modal">
        <i class="fa fa-times"></i>
      </span>
    <h1 v-show="showName">{{productData.productName}}</h1>

    <div v-show="showImage" class="col-xs-12 col-sm-5 productPagePhotoMain">
      <!--<div class="discount" v-show="productData.productHasDiscount"
           v-html="productData.productDisclosure"></div>-->
      <div class="thumbnail_container">
        <div class="thumbnail">
          <picture>
            <source media="(max-width: 270px)" :srcset="mainImage.medium">
            <img :src="mainImage.large"
                 :alt="productData.productName">
          </picture>
        </div>
      </div>
    </div>

    <div :class="showImage ? 'col-xs-12 col-sm-7 productInfoMain ' : 'productInfoMain w-100'">
      <div class="col-12">
        <!--<div class="col-12 productDescription"
             v-show="showContent"
             v-html="productData.productDescription"
             ss-container></div>-->

        <div class="col-12 col-sm-6 productCode productMainCode" v-show="showContent">
          {{ t('product_code.short') }}: <span>{{productData.productId}}</span>
        </div>

        <div class="col-12 col-sm-6 productCode" v-show="showContent && productData.barCodes.length">
          {{ t('product_barcode') }}: <span>{{productData.barCodes[0]}}</span>
        </div>

        <div class="col-12 productPriceBlock" v-show="showContent">
          <!--<span v-show="productData.productHasDiscount" class="col-xs-4 productItemOldPrice">
              <span v-html="priceWithSign(productData.productOldPrice, productData.vCCSign)"></span>
          </span>-->
          <!--<span v-show="productData.productHasDiscount" class="col-xs-8 col-sm-4 productEarn">
            <span id="earnLbl">{{ t('you_earn') }}</span> <span v-html="priceWithSign(diffStringPrices(productData.productOldPrice, productData.productFinalPrice), productData.vCCSign)"></span>
          </span>-->

          <span :class="productPriceClass"
                v-html="priceWithSign(productData.productFinalPrice, productData.vCCSign)"></span>
        </div>

        <!-- Attributes -->
        <attribute-select
          v-if="hasAttributes"
          v-on:matched-product-code="codeIdChanged"
          v-on:product-attribute-selected="attributeSelected"
          :product-id="productId"></attribute-select>
        <div
          class="col-xs-12 col-sm-6 col-md-4 Qty"
          v-if="productCodeId && (inactiveProduct || unavailableProduct)">
          <span v-show="inactiveProduct && config.showInactiveProductCodes">
            {{ t('product_status.unavailable') }}
          </span>
          <span v-show="unavailableProduct && !inactiveProduct">
            {{ t('product_status.unavailable.out_of_stock') }}
          </span>
        </div>
        <!-- Qty-->
        <div
          class="col-xs-6 col-sm-6 col-md-4 Qty"
          v-else>
          <adv-product-input-spinner
            :product-code-id="productCodeId"
            :watch-for-product-code-id-changes="false"
            :max-amount="maxAmountForInputSpinner"
            v-bind:quantity="quantity"
            v-on:quantity-changed="quantityChanged"></adv-product-input-spinner>
        </div>
        <!-- Btn-->
        <div class="col-xs-6 col-sm-6 col-md-8 m-auto ProductAddBlock">
          <adv-cart-button
            class="addToCart"
            :unavailable="unavailableProduct || cartLimitForProductReached"
            :cart-limit-reached="cartLimitForProductReached"
            :has-attributes="hasAttributes"
            :selected-attribute-id="selectedAttributeId"
            v-on:btn-click="addToCard"
            :stock="productCodeData.productStock"
            :progress="progress"
            :productId="this.productId"
            v-bind:quantity="quantity"></adv-cart-button>
        </div>
      </div>
    </div>
  </div>
  </div>
</template>

<script>
import store from '../../vue/store'
import productMixin from './mixins/productMixins'
import AttributeSelect from './attributes/AttributeSelect'
import AdvCartButton from './AdvCartButton'
import AdvProductInputSpinner from './AdvProductInputSpinner'

export default {
  name: 'AdvProductCard',
  components: {
    AttributeSelect,
    AdvCartButton,
    AdvProductInputSpinner
  },
  props: {
    productId: {
      type: Number
    },
    showName: {
      type: Boolean,
      default: false
    },
    showContent: {
      type: Boolean,
      default: false
    },
    showImage: {
      type: Boolean,
      default: false
    },
    modal: {
      type: Boolean,
      default: false
    },
    recommendationType: {
      type: String,
      default: null
    },
    recommendationId: {
      type: String,
      default: null
    }
  },
  mixins: [productMixin],
  data () {
    return {
      version: '0.0.2',
      productCodeId: null,
      quantity: 1,
      showCard: true,
      progress: false,
      mainImage: {
        is_main: '1',
        original: store.state.noImage,
        small: store.state.noImage,
        medium: store.state.noImage,
        large: store.state.noImage
      }
    }
  },
  mounted () {
    this.setProductCodeIdForOneOnOne()
    this.setMainImage()
  },
  watch: {
    productId () {
      this.setProductCodeIdForOneOnOne()
      this.setMainImage()
    }
  },
  computed: {
    rootCss () {
      if (this.modal) {
        return 'modalQuickV'
      }
      return ''
    },
    config () {
      return store.getters.config
    },
    hasAttributes () {
      return this.productData.productCodes.length > 1
    },
    productPriceClass () {
      return 'col-xs-12 ' + (this.productData.productFinalPrice === this.productData.productOldPrice ? '' : 'col-sm-4 ') + 'text-right productItemMainPrice'
    },
    listImage () {
      return this.productData ? this.productData.productImage.list : store.getters.noImage
    },
    inactiveProduct () {
      return !this.productCodeData.productActive
    },
    unavailableProduct () {
      return this.productCodeData.productStock <= 0 || this.productData.productFinalPrice <= 0
    },
    cartQuantity () {
      return this.$store.getters.cartProductCodeQuantity(this.productCodeId, 0)
    },
    cartLimitForProductReached () {
      return this.productCodeData.productStock === this.cartQuantity
    },
    selectedAttributeId () {
      return parseFloat(store.getters.getSelectedAttributeId)
    },
    maxAmountForInputSpinner () {
      return this.productCodeData.productStock - this.cartQuantity
    }
  },
  methods: {
    setProductCodeIdForOneOnOne () {
      if (!this.hasAttributes) {
        this.codeIdChanged(this.productData.productCodes[0].productCodeId)
        return
      }

      this.quantity = 1
    },
    closeModal () {
      this.showCard = false
      this.$emit('close-quick-view')
      this.clearSelectedAttributeId()
    },
    clearSelectedAttributeId () {
      if (this.hasAttributes) {
        store.state.selectedAttributeId = null
      }
    },
    priceWithSign (priceString, priceSign) {
      return (parseFloat(priceString) * store.getters.getSelectedCurrency.rate).toFixed(2) + priceSign
    },
    getSign () {
      return store.getters.getSelectedCurrency.symbol
    },
    diffStringPrices (priceA, priceB) {
      return (parseFloat(priceA) - parseFloat(priceB)).toFixed(2).toString()
    },
    attributeSelected (attributeId) {
      store.dispatch('setSelectedAttributeId', attributeId)
    },
    codeIdChanged (productCodeId) {
      this.productCodeId = productCodeId
      if (this.productCodeId) {
        store.dispatch('setSelectedProductCodeId', this.productCodeId)
        this.setMainImage()
      }
    },
    quantityChanged (quantity) {
      this.quantity = quantity
    },
    addToCard () {
      this.progress = true
      store.dispatch('addToCartClicked', {
        productCodeId: this.productCodeId,
        quantity: this.cartQuantity + this.quantity
      })
        .then(() => {
          this.progress = false
          this.quantity = 1
        })
    },
    setMainImage () {
      if (this.productCodeId) {
        this.mainImage = this.productData.images[this.productCodeId].find(image => image.is_main === '1')
      } else {
        this.mainImage = this.productData.images[parseInt(Object.keys(this.productData.images)[0])].find(image => image.is_main === '1')
      }
    }
  }
}
</script>
